import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectHeaderState } from "../../redux/slices/headerSlice";
import { RoutesMap } from "../../types";
import { Grid } from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { ApiStatus } from "../../types/api/status";
import { useAuthStore } from "../../hooks";
import { Role } from "../../types/roles/roleTypes";
import { ControlCriticalRisk } from "../../types/slices/controlCriticalRiskType";
import { useControlCriticalRiskStore } from "../../hooks/useControlCriticalRisk";
import { useCriticalRiskStore } from "../../hooks/useCriticalRisk";
import { CriticalRisk } from "../../types/slices/criticalRiskType";

const ControlCriticalRiskList: FC = () => {
    const navigate = useNavigate()
    const { user } = useAuthStore()
    const { search } = useSelector(selectHeaderState)
    const { status, controlCriticalRisks, getControlCriticalRisk, deleteControlCriticalRiskStore, setSelectedControlCriticalRisk } = useControlCriticalRiskStore()
    const { criticalRisks, getCriticalRisk } = useCriticalRiskStore()

    const columns = [
        { type: 'options', field: 'options', label: 'OPCIONES', align: 'center' },
        { type: 'text', field: 'name', label: 'NOMBRE DE CONTROL', align: 'center' },
        {
            type: 'text', field: 'critical_risk', label: 'RIESGO CRÍTICO', align: 'center', format: (row: ControlCriticalRisk) => {
                const associatedRisk: CriticalRisk = criticalRisks?.find((critical) => critical.id === row.idcritical_risk) || {} as CriticalRisk;
                return associatedRisk.name
            }
        },
        { type: 'detail', field: 'detail', label: '', align: 'center' },
    ]

    const [loading, setLoading] = useState<boolean>(false)
    const [page, setPage] = useState<number>(0)
    const [rowsPerPage, setRowsPerPage] = useState<number>(10)
    const [rowSelected, setRowSelected] = useState<ControlCriticalRisk>({} as ControlCriticalRisk)
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)
    const userRole: Role | any = user.userType

    useEffect(() => {
        getControlCriticalRiskApi()
    }, [search])

    const getControlCriticalRiskApi = async () => {
        try {
            setLoading(true)
            let payload: any = {}
            if (search !== '') {
                payload = {
                    ...payload,
                    name: search
                }
            }
            await getCriticalRisk()
            await getControlCriticalRisk(payload)
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    const onAdd = () => {
        setSelectedControlCriticalRisk({} as ControlCriticalRisk)
        navigate({ pathname: RoutesMap.CONTROL_CRITICAL_RISK_FORM })
    }

    const onEdit = (rowSelected) => {
        setSelectedControlCriticalRisk(rowSelected)
        navigate({ pathname: RoutesMap.CONTROL_CRITICAL_RISK_FORM })
    }

    const onDelete = (rowSelected) => {
        setRowSelected(rowSelected)
        setShowModalConfirm(true);
    }

    const onDeleteConfirm = async () => {
        const response = await deleteControlCriticalRiskStore(rowSelected.id)
        if (response === true) {
            setSelectedControlCriticalRisk({} as ControlCriticalRisk)
            setShowModalConfirm(false)
            getControlCriticalRiskApi()
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }
    return (
        <>
            <Grid item xs={12}>
                {userRole === Role.ADMIN && (
                    <CustomTable
                        title={'Control de Riegos Críticos'}
                        columns={columns || []}
                        loading={loading}
                        rows={controlCriticalRisks || []}
                        onRowClick={() => { }}
                        hasOptions
                        onAddFn={onAdd}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                )}
                {userRole === Role.MAINTENANCE && (
                    <CustomTable
                        title={'Control de Riegos Críticos'}
                        columns={columns || []}
                        loading={loading}
                        rows={controlCriticalRisks || []}
                        onRowClick={() => { }}
                        hasOptions
                        onAddFn={onAdd}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                )}
            </Grid>
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={() => { setShowModalConfirm(false) }}
                        onCancel={() => { setShowModalConfirm(false) }}
                        onConfirm={onDeleteConfirm}
                        status2={status === ApiStatus.FETCHING ? true : false}
                    />
                )
            }
        </>
    )
}

export default ControlCriticalRiskList

